"use strict";
/**
 * REGISTRY DELLE FORMULE — il catalogo autorevole del calc engine.
 *
 * Ogni formula di dominio ha una entry: id, versione, dove vive
 * l'implementazione, quali output PERSISTITI produce (ciò che un ricalcolo
 * massivo deve rigenerare) e chi la consuma. Il catalogo nasce COMPLETO
 * anche per le formule non ancora migrate qui dentro: prima si mappa la
 * realtà, poi si migra (piano fasi in vault/Architettura/Calcoli e formule.md).
 *
 * Pilastri della visione (2026-07-26):
 *  P1 centralizzazione — una formula in un posto;
 *  P2 ricalcolo massivo — `persistedOutputs` è il grafo di invalidazione;
 *  P3 lineage — ogni esecuzione loggata con formulaId+version+input+sorgenti;
 *  P4 dashboard — il registry è la sorgente della vista calcoli.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.FORMULA_REGISTRY = void 0;
exports.getFormula = getFormula;
exports.formulasWithPersistedOutputs = formulasWithPersistedOutputs;
exports.FORMULA_REGISTRY = [
    {
        id: 'srpe',
        version: 2,
        descrizione: "sRPE sessione = RPE (1-10) × minuti effettivi, ARROTONDATO all'intero. rpeValue nel DB è GIÀ il prodotto. v2 (2026-07-29, decisione prodotto Federico): l'AU è un'unità arbitraria, i decimali sono rumore non precisione — il valore persistito è sempre intero (RPE 7 × 45.5 min → 319, non 318.5). Trigger del ricalcolo massivo P2 su eventResults.rpeValue e sessions.internalLoad.srpe.",
        implementazione: 'packages/calc/src/srpe.ts (sessionSrpe) — write-path che delegano: eventresults.service (create/update RPE), programming/services/workout-logs.service (complete), sessions.service (auto sRPE). Ricalcolo Mongo-side in events.service (PATCH duration evento) usa $floor($add(x,0.5)) = stesso half-up di Math.round.',
        centralizzata: true,
        persistedOutputs: ['eventResults.rpeValue', 'sessions.internalLoad.srpe'],
        consumers: ['readiness', 'effort', 'injuries', 'antifragility', 'mobile'],
    },
    {
        id: 'daily-srpe',
        version: 2,
        descrizione: 'Aggregazione sRPE per giorno logico: rpeValue autorevole se presente, fallback value×duration SOLO per record legacy senza rpeValue, skipped esclusi. v2 (2026-07-28): ritirata la variante legacy che ri-moltiplicava value×duration ignorando rpeValue (bug R1 latente).',
        implementazione: 'packages/calc/src/srpe.ts (dailySrpeMap) — bucketing TZ nei wrapper backend (effort-calculations.dailySrpeFromResults Europe/Rome, utils/generic.buildDailySrpeMap)',
        centralizzata: true,
        persistedOutputs: [],
        consumers: ['readiness', 'effort', 'injuries', 'weekly-reports'],
    },
    {
        id: 'acwr',
        version: 1,
        descrizione: 'ACWR = media acuta 7gg / media cronica 28gg (rolling). Gate storico 21gg.',
        implementazione: 'packages/calc/src/acwr.ts (calculateACWR, hasMinAcwrHistory) — wrapper dayjs in utils/generic.ts e effort-calculations.ts',
        centralizzata: true,
        persistedOutputs: [],
        consumers: ['readiness', 'effort', 'injuries', 'recovery-engine', 'weekly-reports'],
    },
    {
        id: 'monotony-foster',
        version: 1,
        descrizione: 'Monotonia settimanale = media(sRPE giornalieri) / SD popolazione; 0 se SD=0 o <2 giorni.',
        implementazione: 'apps/backend/src/effort/effort-calculations.ts (monotony)',
        centralizzata: false,
        persistedOutputs: [],
        consumers: ['effort', 'weekly-reports', 'recovery-engine'],
    },
    {
        id: 'strain-foster',
        version: 1,
        descrizione: 'Strain = carico settimanale totale × monotonia.',
        implementazione: 'apps/backend/src/effort/effort-calculations.ts (strain)',
        centralizzata: false,
        persistedOutputs: [],
        consumers: ['effort', 'weekly-reports'],
    },
    {
        id: 'recovery-index',
        version: 1,
        descrizione: 'RI = Mentale×.15 + Muscolare×.30 + Cardio×.30 + Strain×.25 con riproporzionamento.',
        implementazione: 'packages/calc/src/recovery.ts (calculateRI, rebalanceWeights) — la lettura dei fattori dal DB resta in apps/backend/src/services/recovery/recovery.service.ts, che importa da qui. Centralizzata il 2026-08-01 per rendere il RI riverificabile dalla dashboard sugli input del lineage.',
        centralizzata: true,
        persistedOutputs: ['recoveryFactors', 'totalRecoveries'],
        consumers: ['readiness', 'mobile', 'alerts'],
    },
    {
        id: 'hooper-composite',
        version: 1,
        descrizione: 'Composito questionario Hooper: media pesata sui 4 item GREZZI 1-5 (sonno .30, fatica .25, doms .25, stress .20; variante RTT ×0.85 + .15) → 1-5, persistito in `average` (AFI a valle). ⚠️ NON è la formula del fattore Mentale del RI: quella è `mentale-score` (item e pesi diversi, vedi hooper.ts). Varianti residue non ancora bonificate: injuries legge nomi campo rotti, load-snapshot fa media grezza (Fase 4a).',
        implementazione: 'packages/calc/src/hooper.ts (hooperComposite) — wrapper computeHooperScore in apps/backend/src/utils/interpolationRecovery.ts',
        centralizzata: true,
        persistedOutputs: ['hooperQuestionnaires.average'],
        consumers: ['antifragility', 'readiness', 'injuries'],
    },
    {
        id: 'mentale-score',
        version: 1,
        descrizione: 'Fattore Mentale del Recovery Index (spec sez. 3.3): item sonno/fatica/stress/UMORE (niente doms — quello va nel Muscolare) convertiti in % via hooperItemRecovery, pesi .30/.30/.20/.20 CON riproporzionamento su item mancanti → 0-100. Formula distinta da `hooper-composite` (scala, item e pesi diversi).',
        implementazione: 'packages/calc/src/hooper.ts (mentaleScore, hooperItemRecovery) — wrapper computeMentaleScore in apps/backend/src/services/recovery/recovery-calculations.ts',
        centralizzata: true,
        persistedOutputs: ['recoveryFactors(type=HOOPER)', 'totalRecoveries.mentaleScore'],
        consumers: ['recovery-engine', 'readiness', 'mobile', 'alerts'],
    },
    {
        id: 'afi',
        version: 1,
        descrizione: 'Antifragility Index (finestre proprie 7/21, UTC).',
        implementazione: 'apps/backend/src/antifragility/antifragility-calculator.ts',
        centralizzata: false,
        persistedOutputs: ['antifragilityScores'],
        consumers: ['afi-tab'],
    },
    {
        id: 'testing-derived',
        version: 1,
        descrizione: 'Derivate testing (RSI, jump height, BMI, LSI, HQ, EUR, percentili, conversioni unità). Semantica BE = canone, invariata (version resta 1). Il duplicato FE è stato ritirato (2026-07-28): il FE ora delega al calc e ha CAMBIATO semantica — LSI giallo ≥85 (era 75), H:Q giallo ≥0.50 (era 0.45), recovery% giallo ≥80 (era 75), percentile midpoint ties + normalizzazione unità kg/lb (era rank strict senza unità), trend flat adattivo σ×0.1 (era 0.01), conversioni con LB_TO_KG/IN_TO_CM unificate.',
        implementazione: 'packages/calc/src/testing.ts — wrapper BE apps/backend/src/utils/testing-calculations.ts, wrapper FE apps/frontend/src/utils/testing-calculations.ts',
        centralizzata: true,
        persistedOutputs: ['testResults'],
        consumers: ['testing', 'profiling', 'frontend'],
    },
    {
        id: 'profiling-p1-p14',
        version: 1,
        descrizione: 'Protocolli profilo P1-P14 (VBT, Samozino, RSI, zone…).',
        implementazione: 'apps/backend/src/profiling/services/profiling-formulas.ts',
        centralizzata: true,
        persistedOutputs: ['profilingResults'],
        consumers: ['profiling', 'programming (closed loop)'],
    },
    {
        id: 'sessions-quality',
        version: 1,
        descrizione: 'Quality/coverage sessioni GPS + baseline gps_*.',
        implementazione: 'apps/backend/src/sessions/pipeline/',
        centralizzata: true,
        persistedOutputs: ['sessionQualities', 'athleteBaselines(gps_*)'],
        consumers: ['carichi'],
    },
    {
        id: 'training-mix',
        version: 1,
        descrizione: 'Composizione del lavoro PIANIFICATO di squadra su un periodo: minuti totali, sedute (distinct localDate+slot), media minuti/seduta, distribuzione % per categoria e sottocategoria, serie temporale. Percentuali a 1 decimale, null quando il totale è 0 (mai 0). Nessun output persistito: tutto on-the-fly, quindi il bump di version NON richiede un RecomputeHandler.',
        implementazione: 'packages/calc/src/training-mix.ts — wrapper backend: training-blocks.service.analysis (pipeline $match/$facet su localDate indicizzato)',
        centralizzata: true,
        persistedOutputs: [],
        consumers: ['allenamenti', 'frontend', 'ai-router'],
    },
    {
        id: 'training-density',
        version: 1,
        descrizione: 'Densità di gioco m²/giocatore: (larghezza×lunghezza)/giocatori, range Stretto/Medio/Ampio/Match-like, media ponderata sui minuti (tempo effettivo se presente), % vs riferimento gara 320. Blocchi eleggibili senza dati esclusi ma conteggiati. On-the-fly, nessun output persistito.',
        implementazione: 'packages/calc/src/training-context.ts — wrapper backend: training-blocks.service.analysis (sezione gameDensity)',
        centralizzata: true,
        persistedOutputs: [],
        consumers: ['allenamenti', 'frontend'],
    },
    {
        id: 'training-player-density',
        version: 1,
        descrizione: 'Distribuzione minuti/blocchi per dimensione del gruppo di giocatori in campo (playersOnField): Individuale=1 · Piccoli=2-4 · Medi=5-8 · Grandi=9+. Per ogni gruppo: minuti pesati, blocchi, % sul totale, m² medio e minuti per modalità (continuo/intermittente/analitico). Blocchi eleggibili senza playersOnField esclusi ma conteggiati. On-the-fly, nessun output persistito.',
        implementazione: 'packages/calc/src/training-context.ts (densitaGiocatori, classificaGruppo, PLAYER_GROUPS) — wrapper backend: training-blocks.service.analysis (sezione playerDensity)',
        centralizzata: true,
        persistedOutputs: [],
        consumers: ['allenamenti', 'frontend'],
    },
    {
        id: 'training-mallo-idc',
        version: 1,
        descrizione: 'Scala Mallo & IDC: CE-tecnico Σ(peso×min)/Σmin, IDC corretto per fattore di flusso (1.00/0.65/0.45), % cognitivo ≥60, % muscolare ≥80, rapporto Continuo/Intermittente con alert <1.0. Include il suggeritore peso+flusso da categoria+titolo. On-the-fly, nessun output persistito.',
        implementazione: 'packages/calc/src/training-mallo.ts — wrapper backend: training-blocks.service.analysis (sezione malloIdc); suggeritore consumato dai form web e mobile',
        centralizzata: true,
        persistedOutputs: [],
        consumers: ['allenamenti', 'frontend', 'mobile'],
    },
    {
        id: 'stagione',
        version: 1,
        descrizione: 'Stagione sportiva canonica 1 luglio → 30 giugno, etichetta "YYYY-YY". Variante dichiarata: stagione-testing (1 settembre → oggi, finestra aperta a destra, 4 siti frontend Testing).',
        implementazione: 'packages/calc/src/training-mix.ts (stagioneDi) — weekly-reports.deriveSeason diventa wrapper (weeklyReports.season è persistito e dentro la chiave di upsert)',
        centralizzata: true,
        persistedOutputs: ['weeklyReports.season'],
        consumers: ['allenamenti', 'weekly-reports', 'training-statistics'],
    },
];
function getFormula(id) {
    return exports.FORMULA_REGISTRY.find((f) => f.id === id);
}
/** Formule con output persistiti = candidate al ricalcolo massivo (P2). */
function formulasWithPersistedOutputs() {
    return exports.FORMULA_REGISTRY.filter((f) => f.persistedOutputs.length > 0);
}
